import { FC, KeyboardEvent, MouseEvent } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from 'src/components';
import * as S from './styles';

const msgs = defineMessages({
  swipeUp: { id: 'blob_session_swipe_up_to_continue', defaultMessage: 'Swipe up to continue' },
});

type SwipeHintProps = {
  onClick: (event?: MouseEvent) => void;
  onKeyUp: (event: KeyboardEvent) => void;
};

export const SwipeHint: FC<SwipeHintProps> = ({ onClick, onKeyUp }) => {
  const intl = useIntl();

  return (
    <S.Hint type="button" onClick={onClick} onKeyUp={onKeyUp} data-testid="blob-swipe-hint">
      <Icon name="up" />
      {intl.formatMessage(msgs.swipeUp)}
    </S.Hint>
  );
};
